// extracted by mini-css-extract-plugin
export default {"showMoreButtonWrapper":"articles-module__showMoreButtonWrapper--WUEpY","showMoreButton":"articles-module__showMoreButton--Slc9B"};